import { Module } from "@com.mgmtp.a12.client/client-core/lib/core/application";

import { deliverProcessNotificationsSaga } from "./sagas/deliverProcessNotifications";

/**
 * Delivers user-facing notifications stored by the server in the document during inter-step processing
 * as toasts to the user and marks them as delivered to the server.
 */
const processNotificationsModule = (): Module => ({
	id: "ProcessNotificationsModule",
	sagas: () => [deliverProcessNotificationsSaga]
});

export default processNotificationsModule;
